<script lang="ts">
  import tippy from 'tippy.js';

  export let source: string | undefined;

  let isYouTube: HTMLElement;
  let isVimeo: HTMLElement;
  let isFacebook: HTMLElement;
  let isGoogleDrive: HTMLElement;
  let isDropbox: HTMLElement;
  let isLiveStream: HTMLElement;
  let isLocal: HTMLElement;
  let isResi: HTMLElement;

  $: {
    if (isYouTube) {
      tippy(isYouTube, {
        theme: 'ssneutral',
        content: `<div class="flex flex-col items-center justify-start">
                            <p class="inline-block align-middle font-base text-gray-800">YouTube</p>
                        </div>`,
        allowHTML: true,
        placement: 'top',
        arrow: true,
        animation: 'scale'
      });
    }
    if (isLiveStream) {
      tippy(isLiveStream, {
        theme: 'ssneutral',
        content: `<div class="flex flex-col items-center justify-start">
                            <p class="inline-block align-middle font-base text-gray-800">Live Stream</p>
                        </div>`,
        allowHTML: true,
        placement: 'top',
        arrow: true,
        animation: 'scale'
      });
    }
    if (isLocal) {
      tippy(isLocal, {
        theme: 'ssneutral',
        content: `<div class="flex flex-col items-center justify-start">
                            <p class="inline-block align-middle font-base text-gray-800">Computer</p>
                        </div>`,
        allowHTML: true,
        placement: 'top',
        arrow: true,
        animation: 'scale'
      });
    }
    if (isVimeo) {
      tippy(isVimeo, {
        theme: 'ssneutral',
        content: `<div class="flex flex-col items-center justify-start">
                            <p class="inline-block align-middle font-base text-gray-800">Vimeo</p>
                        </div>`,
        allowHTML: true,
        placement: 'top',
        arrow: true,
        animation: 'scale'
      });
    }
    if (isFacebook) {
      tippy(isFacebook, {
        theme: 'ssneutral',
        content: `<div class="flex flex-col items-center justify-start">
                            <p class="inline-block align-middle font-base text-gray-800">Facebook</p>
                        </div>`,
        allowHTML: true,
        placement: 'top',
        arrow: true,
        animation: 'scale'
      });
    }
    if (isGoogleDrive) {
      tippy(isGoogleDrive, {
        theme: 'ssneutral',
        content: `<div class="flex flex-col items-center justify-start">
                            <p class="inline-block align-middle font-base text-gray-800">Google Drive</p>
                        </div>`,
        allowHTML: true,
        placement: 'top',
        arrow: true,
        animation: 'scale'
      });
    }
    if (isDropbox) {
      tippy(isDropbox, {
        theme: 'ssneutral',
        content: `<div class="flex flex-col items-center justify-start">
                            <p class="inline-block align-middle font-base text-gray-800">Dropbox</p>
                        </div>`,
        allowHTML: true,
        placement: 'top',
        arrow: true,
        animation: 'scale'
      });
    }
    if (isResi) {
      tippy(isResi, {
        theme: 'ssneutral',
        content: `<div class="flex flex-col items-center justify-start">
                            <p class="inline-block align-middle font-base text-gray-800">Resi</p>
                        </div>`,
        allowHTML: true,
        placement: 'top',
        arrow: true,
        animation: 'scale'
      });
    }
  }
</script>

<span class="pt-1 text-xs text-gray-400 lg:text-sm">
  {#if source == 'youtube'}
    <span bind:this={isYouTube}>
      <i class="fa-brands fa-youtube"></i>
    </span>
  {:else if source == 'stream'}
    <span bind:this={isLiveStream}>
      <i class="fa-solid fa-signal-stream"></i>
    </span>
  {:else if source == 'vimeo'}
    <span bind:this={isVimeo}>
      <i class="fa-brands fa-vimeo"></i>
    </span>
  {:else if source == 'facebook'}
    <span bind:this={isFacebook}>
      <i class="fa-brands fa-facebook"></i>
    </span>
  {:else if source == 'google-drive'}
    <span bind:this={isGoogleDrive}>
      <i class="fa-brands fa-google-drive"></i>
    </span>
  {:else if source == 'dropbox'}
    <span bind:this={isDropbox}>
      <i class="fa-brands fa-dropbox"></i>
    </span>
  {:else if source == 'resi'}
    <span bind:this={isResi}>
      <svg width="14" height="14">
        <image
          class="mix-blend-multiply grayscale"
          xlink:href="https://storage.googleapis.com/sermonshots-local-storage/images/resi-icon.webp"
          width="14"
          height="14"
        />
      </svg>
    </span>
  {:else}
    <span bind:this={isLocal}>
      <i class="fa-solid fa-folder"></i>
    </span>
  {/if}
</span>
